import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL 
      ? `${process.env.REACT_APP_API_URL}/api/v1/mitra` 
      : 'http://localhost:8001/api/v1/mitra',
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;
